import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import { createRoot } from 'react-dom/client'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import store from './store'
import packagejson from '../package.json'
import GlobalContextPrivers from './GlobalContextProviders'
import { PublicClientApplication, EventType } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { getAzureAuthConfig } from './azureAuthConfig'
import { decryptData } from './tools/CryptoHelper'
import { ConfigProvider } from 'antd'

const App = React.lazy(() => import('./App'))

const title = document.title
document.title = `${title} v${packagejson.version}`

// initialize dynamicJsArray
window.dynamicJsArray = []

/**
 * Initialize a PublicClientApplication instance which is provided to the MsalProvider component
 * We recommend initializing this outside of your root component to ensure it is not re-initialized on re-renders
 */
let msalInstance = null // = new PublicClientApplication(msalConfig)

const PreLoad = () => {
  const [loaded, setLoaded] = React.useState(false)
  React.useEffect(() => {
    ;(async function () {
      // let response = null
      // //const response = await fetch(`${process.env.PUBLIC_URL}/env.json`)
      // if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      //   response = await fetch('https://localhost:7098/ClientConfig/V1/NexGen')
      // } else {
      //   if (window.location.hostname.includes('sqannexgen-dev.')) {
      //     response = await fetch('https://sqanapi-dev.iqor.com/ClientConfig/V1/NexGen')
      //   } else if (window.location.hostname.includes('sqannexgen-qa.')) {
      //     response = await fetch('https://sqanapi-qa.iqor.com/ClientConfig/V1/NexGen')
      //   } else if (window.location.hostname.includes('sqanclient-qa.')) {
      //     response = await fetch('https://sqanapiclient-qa.iqor.com/ClientConfig/V1/NexGen')
      //   } else if (window.location.hostname.includes('aqcessuat.iqor')) {
      //     response = await fetch('https://aqcessuat.iqor.com/api/ClientConfig/V1/NexGen')
      //   } else if (window.location.hostname.includes('aqcess.iqor')) {
      //     response = await fetch('https://aqcess.iqor.com/api/ClientConfig/V1/NexGen')
      //   } else if (window.location.hostname.includes('sqanclient.')) {
      //     response = await fetch('https://sqanclientapi.iqor.com/ClientConfig/V1/NexGen')
      //   } else {
      //     response = await fetch('https://sqanapi.iqor.com/ClientConfig/V1/NexGen')
      //   }
      // }

      // const data = await response.json()
      // window.envConfig = data

      let configResponse = null
      if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        configResponse = await fetch('https://localhost:7098/ClientConfig/V1/Config')
      } else {
        if (window.location.hostname.includes('sqannexgen-dev.')) {
          configResponse = await fetch('https://sqanapi-dev.iqor.com/ClientConfig/V1/Config')
        } else if (window.location.hostname.includes('sqannexgen-qa.')) {
          configResponse = await fetch('https://sqanapi-qa.iqor.com/ClientConfig/V1/Config')
        } else if (window.location.hostname.includes('sqanclient-qa.')) {
          configResponse = await fetch('https://sqanapiclient-qa.iqor.com/ClientConfig/V1/Config')
        } else if (window.location.hostname.includes('aqcessuat.iqor')) {
          configResponse = await fetch('https://aqcessuat.iqor.com/api/ClientConfig/V1/Config')
        } else if (window.location.hostname.includes('aqcess.iqor')) {
          configResponse = await fetch('https://aqcess.iqor.com/api/ClientConfig/V1/Config')
        } else if (window.location.hostname.includes('sqanclient.')) {
          configResponse = await fetch('https://sqanclientapi.iqor.com/ClientConfig/V1/Config')
        } else {
          configResponse = await fetch('https://sqanapi.iqor.com/ClientConfig/V1/Config')
        }
      }

      const config = await configResponse.text()

      let clientConfigUrl = 'https://sqanapi.iqor.com/ClientConfig/V1/NexGenEn'
      if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        clientConfigUrl = 'https://localhost:7098/ClientConfig/V1/NexGenEn'
      } else {
        if (window.location.hostname.includes('sqannexgen-dev.')) {
          clientConfigUrl = 'https://sqanapi-dev.iqor.com/ClientConfig/V1/NexGenEn'
        } else if (window.location.hostname.includes('sqannexgen-qa.')) {
          clientConfigUrl = 'https://sqanapi-qa.iqor.com/ClientConfig/V1/NexGenEn'
        } else if (window.location.hostname.includes('sqanclient-qa.')) {
          clientConfigUrl = 'https://sqanapiclient-qa.iqor.com/ClientConfig/V1/NexGenEn'
        } else if (window.location.hostname.includes('aqcessuat.iqor')) {
          clientConfigUrl = 'https://aqcessuat.iqor.com/api/ClientConfig/V1/NexGenEn'
        } else if (window.location.hostname.includes('aqcess.iqor')) {
          clientConfigUrl = 'https://aqcess.iqor.com/api/ClientConfig/V1/NexGenEn'
        } else if (window.location.hostname.includes('sqanclient.')) {
          clientConfigUrl = 'https://sqanclientapi.iqor.com/ClientConfig/V1/NexGenEn'
        } else {
          clientConfigUrl = 'https://sqanapi.iqor.com/ClientConfig/V1/NexGenEn'
        }
      }

      const response = await fetch(clientConfigUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          option: config,
        }),
      })

      const data = await response.text()

      const decrytedValue = decryptData(data, config)

      window.envConfig = JSON.parse(decrytedValue)

      msalInstance = new PublicClientApplication(getAzureAuthConfig())

      // // Default to using the first account if no account is active on page load
      // if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
      //   // Account selection logic is app dependent. Adjust as needed for different use cases.
      //   msalInstance.setActiveAccount(msalInstance.getActiveAccount()[0])
      // }

      // Optional - This will update account state if a user signs in from another tab or window
      msalInstance.enableAccountStorageEvents()

      // Listen for sign-in event and set active account
      msalInstance.addEventCallback((event) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
          const account = event.payload.account
          msalInstance.setActiveAccount(account)
        }
      })

      setLoaded(true)
    })()
  }, [])
  return (
    loaded && (
      <React.Suspense fallback={<div className="animated fadeIn pt-3 text-center">Loading...</div>}>
        <MsalProvider instance={msalInstance}>
          <Provider store={store}>
            <GlobalContextPrivers>
              <ConfigProvider
                theme={{
                  token: {
                    fontFamily: 'Telegraf-Regular',
                  },
                }}
              >
                <App />
              </ConfigProvider>
            </GlobalContextPrivers>
          </Provider>
        </MsalProvider>
      </React.Suspense>
    )
  )
}

const container = document.getElementById('root')
const root = createRoot(container)

root.render(<PreLoad />)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
